(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initializeCarousel = (carousel) => {
      if (carousel.dataset.initialized === 'true') return;

      const viewport = carousel.querySelector('[data-carousel-viewport]');
      const previousButton = carousel.querySelector('[data-carousel-previous]');
      const nextButton = carousel.querySelector('[data-carousel-next]');

      if (!viewport || !previousButton || !nextButton) return;

      carousel.dataset.initialized = 'true';
      carousel.classList.add('is-enhanced');

      const itemCount = Number(carousel.dataset.itemCount || 0);
      const autoplayEnabled = carousel.dataset.autoplay === 'true' && itemCount > 4 && !reducedMotion.matches;
      const interval = Number(carousel.dataset.interval || 5000);
      let autoplayTimer;
      let scrollFrame;

      const atStart = () => viewport.scrollLeft <= 2;
      const atEnd = () => viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
      const hasOverflow = () => viewport.scrollWidth > viewport.clientWidth + 2;

      const updateControls = () => {
        const overflowing = hasOverflow();
        carousel.classList.toggle('is-overflowing', overflowing);
        previousButton.disabled = !overflowing || atStart();
        nextButton.disabled = !overflowing || atEnd();
      };

      const pageDistance = () => {
        const firstItem = viewport.querySelector('[data-carousel-item]');
        if (!firstItem) return viewport.clientWidth;

        const styles = getComputedStyle(viewport);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const itemWidth = firstItem.getBoundingClientRect().width + gap;
        const itemsPerPage = Math.max(1, Math.round((viewport.clientWidth + gap) / itemWidth));
        return itemWidth * itemsPerPage;
      };

      const scrollPage = (direction) => {
        viewport.scrollBy({
          left: pageDistance() * direction,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || !hasOverflow() || document.hidden) return;

        autoplayTimer = window.setInterval(() => {
          if (atEnd()) {
            viewport.scrollTo({ left: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
          } else {
            scrollPage(1);
          }
        }, interval);
      };

      previousButton.addEventListener('click', () => scrollPage(-1));
      nextButton.addEventListener('click', () => scrollPage(1));
      carousel.addEventListener('pointerenter', stopAutoplay);
      carousel.addEventListener('pointerleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) startAutoplay();
      });
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      }, { passive: true });
      window.addEventListener('resize', () => {
        updateControls();
        startAutoplay();
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      updateControls();
      startAutoplay();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-bestseller-carousel]').forEach(initializeCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    if (form.dataset.enhanced === 'true') return;
    form.dataset.enhanced = 'true';

    const updateButton = form.querySelector('[data-cart-update]');
    const status = form.querySelector('[data-cart-status]');
    let updateTimer;

    if (updateButton) updateButton.hidden = true;

    const setBusy = () => {
      window.clearTimeout(updateTimer);
      form.setAttribute('aria-busy', 'true');
      if (status) status.textContent = form.dataset.updatingLabel;
      form.querySelectorAll('button').forEach((control) => {
        control.disabled = true;
      });
    };

    const submitCart = (skipValidation = false) => {
      setBusy();
      if (skipValidation) {
        form.submit();
      } else {
        form.requestSubmit();
      }
    };

    const scheduleUpdate = () => {
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(() => submitCart(), 450);
    };

    const normalizeQuantity = (input) => {
      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      const increment = Number(input.step || 1);
      const value = Number(input.value || minimum);
      const steppedValue = minimum + Math.round((value - minimum) / increment) * increment;
      input.value = String(Math.max(minimum, Math.min(maximum, steppedValue)));
    };

    const updateStepperState = (line) => {
      const input = line.querySelector('[data-cart-quantity-input]');
      if (!input) return;
      const value = Number(input.value || input.min || 1);
      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      const minus = line.querySelector('[data-quantity-minus]');
      const plus = line.querySelector('[data-quantity-plus]');
      if (minus) minus.disabled = value <= minimum;
      if (plus) plus.disabled = value >= maximum;
    };

    form.querySelectorAll('[data-cart-line]').forEach(updateStepperState);

    form.addEventListener('click', (event) => {
      const line = event.target.closest('[data-cart-line]');
      if (!line) return;

      const input = line.querySelector('[data-cart-quantity-input]');
      if (!input) return;

      if (event.target.closest('[data-cart-remove]')) {
        input.value = '0';
        submitCart(true);
        return;
      }

      const stepperButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
      if (!stepperButton) return;

      const previousValue = input.value;
      const increment = Number(input.step || 1);
      const direction = stepperButton.matches('[data-quantity-minus]') ? -1 : 1;
      input.value = String(Number(input.value || input.min || 1) + increment * direction);
      normalizeQuantity(input);
      updateStepperState(line);
      if (input.value !== previousValue) scheduleUpdate();
    });

    form.addEventListener('change', (event) => {
      if (!event.target.matches('[data-cart-quantity-input]')) return;
      normalizeQuantity(event.target);
      updateStepperState(event.target.closest('[data-cart-line]'));
      scheduleUpdate();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  const collapseCollectionNavigation = (root = document) => {
    if (!window.matchMedia('(max-width: 860px)').matches) return;
    root.querySelectorAll('[data-collection-nav]').forEach((navigation) => {
      navigation.removeAttribute('open');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => collapseCollectionNavigation(), { once: true });
  } else {
    collapseCollectionNavigation();
  }

  document.addEventListener('shopify:section:load', (event) => {
    collapseCollectionNavigation(event.target);
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-category-toggle]');
    if (!toggle) return;

    const children = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!children) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    children.hidden = isExpanded;
  });

  document.addEventListener('change', (event) => {
    const sortSelect = event.target.closest('[data-collection-sort]');
    if (sortSelect) sortSelect.form.requestSubmit();

    const pageSizeSelect = event.target.closest('[data-collection-page-size]');
    if (!pageSizeSelect) return;

    const url = new URL(window.location.href);
    url.searchParams.set('view', `products-${pageSizeSelect.value}`);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-tools"]) return;
  try {
    
  document.querySelectorAll('[data-floating-tools]').forEach((tools) => {
    const service = tools.querySelector('[data-customer-service]');
    const trigger = tools.querySelector('[data-customer-trigger]');

    if (service && trigger) {
      const setServiceOpen = (open) => {
        service.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
      };

      service.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') setServiceOpen(true);
      });

      service.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        setServiceOpen(false);
        if (document.activeElement === trigger) trigger.blur();
      });

      service.addEventListener('focusin', () => setServiceOpen(true));
      service.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!service.contains(document.activeElement)) setServiceOpen(false);
        });
      });

      trigger.addEventListener('click', () => {
        setServiceOpen(!service.classList.contains('is-open'));
      });

      document.addEventListener('click', (event) => {
        if (!service.contains(event.target)) setServiceOpen(false);
      });

      service.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        setServiceOpen(false);
        trigger.focus();
      });
    }

    const button = tools.querySelector('[data-back-to-top]');
    if (!button) return;

    const updateVisibility = () => {
      button.hidden = window.scrollY < 480;
    };

    button.addEventListener('click', () => {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      window.scrollTo({ top: 0, behavior });
    });

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-site-header]').forEach((header) => {
    const menu = header.querySelector('[data-primary-navigation]');
    const menuToggle = header.querySelector('[data-menu-toggle]');

    menuToggle?.addEventListener('click', () => {
      const isOpen = menu.dataset.open === 'true';
      menu.dataset.open = String(!isOpen);
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });

    header.querySelectorAll('[data-submenu-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const item = toggle.closest('[data-nav-item]');
        const isOpen = item.dataset.open === 'true';
        item.dataset.open = String(!isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    const accountMenu = header.querySelector('[data-account-menu]');
    const accountTrigger = accountMenu?.querySelector('[data-account-trigger]');
    const accountPopover = accountMenu?.querySelector('[data-account-popover]');
    const languageMenu = header.querySelector('[data-language-menu]');
    const languageTrigger = languageMenu?.querySelector('summary');

    const setAccountMenuOpen = (isOpen) => {
      if (!accountTrigger || !accountPopover) return;
      accountTrigger.setAttribute('aria-expanded', String(isOpen));
      accountPopover.hidden = !isOpen;
    };

    accountTrigger?.addEventListener('click', () => {
      const shouldOpen = accountTrigger.getAttribute('aria-expanded') !== 'true';
      setAccountMenuOpen(shouldOpen);
      if (shouldOpen) languageMenu?.removeAttribute('open');
    });

    languageMenu?.addEventListener('toggle', () => {
      if (languageMenu.open) setAccountMenuOpen(false);
    });

    accountPopover?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setAccountMenuOpen(false));
    });

    document.addEventListener('click', (event) => {
      if (accountMenu && !accountMenu.contains(event.target)) setAccountMenuOpen(false);
      if (languageMenu?.open && !languageMenu.contains(event.target)) languageMenu.removeAttribute('open');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && accountTrigger?.getAttribute('aria-expanded') === 'true') {
        setAccountMenuOpen(false);
        accountTrigger.focus();
      }

      if (event.key === 'Escape' && languageMenu?.open) {
        languageMenu.removeAttribute('open');
        languageTrigger?.focus();
      }
    });

    const searchTrigger = header.querySelector('[data-search-open]');
    const searchDialogId = searchTrigger?.getAttribute('aria-controls');
    const searchDialog = searchDialogId ? document.getElementById(searchDialogId) : null;

    if (!searchTrigger || !searchDialog) return;

    const searchInput = searchDialog.querySelector('[data-search-input]');
    const searchResults = searchDialog.querySelector('[data-search-results]');
    const rootUrl = searchDialog.dataset.searchRootUrl || '/';
    const defaultSearchNodes = [...searchResults.childNodes].map((node) => node.cloneNode(true));
    let searchTimer;
    let searchRequest;

    const restoreDefaultResults = () => {
      searchResults.replaceChildren(...defaultSearchNodes.map((node) => node.cloneNode(true)));
    };

    const setSearchMessage = (message) => {
      searchResults.replaceChildren();
      const paragraph = document.createElement('p');
      paragraph.className = 'header-search__message';
      paragraph.textContent = message;
      searchResults.append(paragraph);
    };

    const renderSearchResults = (resources) => {
      const resultTypes = [
        ['products', searchDialog.dataset.searchProductLabel],
        ['pages', searchDialog.dataset.searchPageLabel],
        ['articles', searchDialog.dataset.searchArticleLabel],
      ];
      const items = resultTypes.flatMap(([key, label]) =>
        (resources[key] || []).map((item) => ({ item, label })),
      ).slice(0, 5);

      if (items.length === 0) {
        setSearchMessage(searchDialog.dataset.searchNoSuggestions);
        return;
      }

      const list = document.createElement('ul');
      list.className = 'header-search__list';

      items.forEach(({ item, label }) => {
        const listItem = document.createElement('li');
        const link = document.createElement('a');
        const media = document.createElement('span');
        const title = document.createElement('span');

        link.className = 'header-search__result-link';
        link.href = item.url;
        link.setAttribute('aria-label', `${item.title}, ${label}`);
        media.className = 'header-search__result-media';
        media.setAttribute('aria-hidden', 'true');
        title.className = 'header-search__result-title';
        title.textContent = item.title;

        const imageUrl = item.featured_image?.url;
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = '';
          image.loading = 'lazy';
          media.append(image);
        } else {
          media.textContent = item.title.slice(0, 1).toUpperCase();
        }

        link.append(media, title);
        listItem.append(link);
        list.append(listItem);
      });

      searchResults.replaceChildren(list);
    };

    const fetchSearchResults = async (term) => {
      searchRequest?.abort();
      searchRequest = new AbortController();

      const endpoint = `${rootUrl}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last`;

      try {
        const response = await fetch(endpoint, { signal: searchRequest.signal });
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        const data = await response.json();
        renderSearchResults(data.resources?.results || {});
      } catch (error) {
        if (error.name !== 'AbortError') setSearchMessage(searchDialog.dataset.searchNoSuggestions);
      }
    };

    const openSearch = () => {
      if (typeof searchDialog.showModal !== 'function') {
        window.location.assign(searchTrigger.dataset.searchFallbackUrl);
        return;
      }

      if (!searchDialog.open) searchDialog.showModal();
      requestAnimationFrame(() => searchInput.focus());
    };

    searchTrigger.addEventListener('click', openSearch);
    searchDialog.addEventListener('close', () => searchTrigger.focus());
    searchDialog.addEventListener('click', (event) => {
      if (event.target === searchDialog) searchDialog.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchDialog.open) {
        event.preventDefault();
        searchDialog.close();
        return;
      }

      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        openSearch();
      }
    });

    searchInput.addEventListener('input', () => {
      const term = searchInput.value.trim();
      clearTimeout(searchTimer);
      searchRequest?.abort();

      if (term.length < 2) {
        restoreDefaultResults();
        return;
      }

      searchTimer = window.setTimeout(() => fetchSearchResults(term), 220);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medical-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const instances = new WeakMap();

    const initializeCarousel = (carousel) => {
      if (carousel.dataset.initialized === 'true') return;

      const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
      const previousButton = carousel.querySelector('[data-hero-previous]');
      const nextButton = carousel.querySelector('[data-hero-next]');
      const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
      const status = carousel.querySelector('[data-hero-status]');

      if (slides.length < 2 || !previousButton || !nextButton) return;

      carousel.dataset.initialized = 'true';
      carousel.classList.add('is-enhanced');

      const interval = Number(carousel.dataset.interval || 6000);
      let currentIndex = 0;
      let autoplayTimer;

      const syncVideos = () => {
        slides.forEach((slide, index) => {
          slide.querySelectorAll('video').forEach((video) => {
            if (index === currentIndex && !reducedMotion.matches) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };

      const goTo = (nextIndex, announce = false) => {
        currentIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const active = index === currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a, button').forEach((element) => {
            if (active) element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', '-1');
          });
        });

        dots.forEach((dot, index) => {
          const active = index === currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });

        syncVideos();
        if (announce && status) status.textContent = slides[currentIndex].getAttribute('aria-label');
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (carousel.dataset.autoplay !== 'true' || reducedMotion.matches || document.hidden) return;
        autoplayTimer = window.setInterval(() => goTo(currentIndex + 1), interval);
      };

      previousButton.addEventListener('click', () => goTo(currentIndex - 1, true));
      nextButton.addEventListener('click', () => goTo(currentIndex + 1, true));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(Number(dot.dataset.slideIndex), true));
      });
      carousel.addEventListener('pointerenter', stopAutoplay);
      carousel.addEventListener('pointerleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) startAutoplay();
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });
      reducedMotion.addEventListener('change', () => {
        syncVideos();
        if (reducedMotion.matches) stopAutoplay();
        else startAutoplay();
      });

      instances.set(carousel, { goTo });
      goTo(0);
      startAutoplay();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-hero-carousel]').forEach(initializeCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-hero-slide]');
      const carousel = slide?.closest('[data-hero-carousel]');
      const instance = carousel ? instances.get(carousel) : null;
      if (slide && instance) instance.goTo(Number(slide.dataset.slideIndex));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-qualifications"] && !Shopify.designMode) return;
  try {
    
  const initializeQualificationGalleries = (root = document) => {
    const galleries = root.matches?.('[data-qualification-gallery]')
      ? [root]
      : root.querySelectorAll('[data-qualification-gallery]');

    galleries.forEach((gallery) => {
      if (gallery.dataset.initialized === 'true') return;

      const track = gallery.querySelector('[data-gallery-track]');
      const previous = gallery.querySelector('[data-gallery-previous]');
      const next = gallery.querySelector('[data-gallery-next]');
      if (!track || !previous || !next) return;

      gallery.dataset.initialized = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let scrollFrame;

      const hasOverflow = () => track.scrollWidth > track.clientWidth + 2;
      const edgeTolerance = () => (Number.parseFloat(getComputedStyle(track).paddingInlineStart) || 0) + 2;
      const atStart = () => track.scrollLeft <= edgeTolerance();
      const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - edgeTolerance();

      const updateControls = () => {
        const overflowing = hasOverflow();
        const wasOverflowing = gallery.classList.contains('is-overflowing');
        gallery.classList.toggle('is-overflowing', overflowing);

        if (overflowing && !wasOverflowing) track.scrollLeft = 0;
        previous.disabled = !overflowing || atStart();
        next.disabled = !overflowing || atEnd();
      };

      const pageDistance = () => {
        const firstCard = track.querySelector('.qualification-card');
        if (!firstCard) return track.clientWidth;

        const styles = getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const itemWidth = firstCard.getBoundingClientRect().width + gap;
        const itemsPerPage = Math.max(1, Math.floor((track.clientWidth + gap) / itemWidth));
        return itemWidth * itemsPerPage;
      };

      const scrollPage = (direction) => {
        track.scrollBy({
          left: pageDistance() * direction,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      previous.addEventListener('click', () => scrollPage(-1));
      next.addEventListener('click', () => scrollPage(1));
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      }, { passive: true });
      window.addEventListener('resize', updateControls);

      updateControls();
      gallery.classList.add('is-enhanced');
    });
  };

  initializeQualificationGalleries();

  document.addEventListener('shopify:section:load', (event) => {
    initializeQualificationGalleries(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-strip"] && !Shopify.designMode) return;
  try {
    
  const initializePromotionStrips = (root = document) => {
    const strips = root.matches?.('[data-promotion-strip]')
      ? [root]
      : root.querySelectorAll('[data-promotion-strip]');

    strips.forEach((strip) => {
      if (strip.dataset.initialized === 'true') return;
      strip.dataset.initialized = 'true';

      const closeButton = strip.querySelector('[data-promotion-close]');
      const storageKey = strip.dataset.promotionStorageKey;
      const isThemeEditor = Boolean(window.Shopify?.designMode);

      if (!isThemeEditor && storageKey) {
        try {
          strip.hidden = window.sessionStorage.getItem(storageKey) === 'dismissed';
        } catch (_error) {
          // Storage may be unavailable in privacy-restricted browsers; closing still works for the current page.
        }
      }

      closeButton?.addEventListener('click', () => {
        strip.hidden = true;

        if (!isThemeEditor && storageKey) {
          try {
            window.sessionStorage.setItem(storageKey, 'dismissed');
          } catch (_error) {
            // The banner remains dismissed for the current page even when storage is unavailable.
          }
        }

        document.getElementById('MainContent')?.focus({ preventScroll: true });
      });
    });
  };

  initializePromotionStrips();

  document.addEventListener('shopify:section:load', (event) => {
    initializePromotionStrips(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
